module.exports = __webpack_public_path__ + "img/delivery-service-documnet.541cad24.svg";